import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ExportStatusState = 'processing' | 'success' | 'error';

export interface ExportStatusItem {
  id: number;
  model: string;
  label: string;
  status: ExportStatusState;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class ExportStatusService {
  private readonly exportRequestsSubject = new BehaviorSubject<ExportStatusItem[]>([]);
  readonly exportRequests$ = this.exportRequestsSubject.asObservable();

  start(exportRequest: ExportStatusItem) {
    const currentRequests = this.exportRequestsSubject.getValue();
    this.exportRequestsSubject.next([
      exportRequest,
      ...currentRequests.filter(item => item.id !== exportRequest.id),
    ]);
  }

  update(exportId: number, status: ExportStatusState, message: string) {
    const currentRequests = this.exportRequestsSubject.getValue();
    this.exportRequestsSubject.next(
      currentRequests.map(item =>
        item.id === exportId
          ? { ...item, status, message }
          : item
      )
    );
  }

  dismiss(exportId: number) {
    const currentRequests = this.exportRequestsSubject.getValue();
    this.exportRequestsSubject.next(
      currentRequests.filter(item => item.id !== exportId)
    );
  }
}
